import { useCallback, useState } from "react";
import { Offcanvas } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { connect, useDispatch } from "react-redux";
import { AppConstant } from "../../redux/reducers";
import { MClose } from "../commons/MIcon";
import TermDoc from "../testComponents/TermDoc";

const TermsSidebar = ({ show }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [fillScreen, setFillScreen] = useState(false);

  const handlerClose = useCallback(() => {
    dispatch({ type: AppConstant.SET_SHOW_TEAMS, show: false });
  }, [dispatch])

  return <>
    <Offcanvas
      show={show}
      onHide={handlerClose}
      placement="bottom"
      className="w-100 z-index-1047"
      backdropClassName="z-index-1046"
      style={{
        borderTopLeftRadius: 24,
        borderTopRightRadius: 24,
        height: show ? (fillScreen ? "calc(100vh - 72px)" : "65vh") : 0,
        transition: "all 0.2s",
      }}
      backdrop="static"
    >
      {show && <>
        <div
          className="position-absolute rounded-circle bg-white d-flex align-items-center justify-content-center cursor-pointer"
          style={{
            right: 16,
            top: -56,
            width: 40,
            height: 40,
          }}
          onClick={handlerClose}
        >
          <MClose className="text-gray-900" />
        </div>
      </>}
      <Offcanvas.Header
        className="align-items-center justify-content-center"
        onClick={() => setFillScreen(prev => !prev)}
      >
        <div
          className="bg-secondary-300"
          style={{
            width: "20%",
            maxWidth: 300,
            height: 6,
            borderRadius: 3,
          }}
        />
      </Offcanvas.Header>
      <Offcanvas.Body className="d-flex flex-column gap-2">
        <div className="fw-bolder">
          {t("Terms and Conditions")}
        </div>
        <div className="w-100 flex-fill position-relative">
          {/* TODO: 약관 으로 대체 */}
          <TermDoc />
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  </>
};

const mapState = (state) => {
  const show = state.AppReducer.show.teams;
  return { show };
};

const mapDispatch = dispatch => ({

})

export default connect(mapState, mapDispatch)(TermsSidebar);
